// extracted by mini-css-extract-plugin
export default {"scoreboard":"Score_scoreboard__TwWlO","score":"Score_score__sAqSl"};